"use strict";
/**
 * @class SVGCStackBadge
 * @description stack badge svg
 */
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable max-line-length
var React = require("react");
var BadgeLabel_1 = require("./BadgeLabel");
var SVGStackBadge = function (_a) {
    var text = _a.text;
    return (React.createElement("svg", { version: "1.1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 75 100", className: "oui__badge-stack" },
        React.createElement("path", { d: "M37.2,0C16.6,0,0,8.4,0,18.6v62.8C0,91.6,16.6,100,37.2,100c20.6,0,37.2-8.4,37.2-18.6V18.6C74.4,8.4,57.6,0,37.2,0z" }),
        React.createElement(BadgeLabel_1.default, { text: text })));
};
exports.default = SVGStackBadge;
//# sourceMappingURL=SVGStackBadge.js.map